import React, { useEffect, useState, useRef } from 'react'
import strings from 'strings'
import { Alert } from '@material-ui/lab'
import { getSosQuickSearch, getSosSearch } from 'actions/applicants'
import SearchResultCard from './SearchResultCard'
import { MAX_RETRIES_FOR_SOS_SEARCH } from 'constants/application'

const sosStrings = strings.APPLICANT.SOS

const CurrentSearch = (props) => {

    const { viewResult, currentSearch, search, isQuickSearch, applicantId, refreshSavedRecords, creditCosts } = props
    const sosSearchId = currentSearch?.sosSearchId
    const state = currentSearch?.state

    const getSearchResult = isQuickSearch ? getSosQuickSearch : getSosSearch

    const [searchResult, setSearchResult] = useState(null)
    const [possibleAlternatives, setPossibleAlternatives] = useState([])
    const [relatedBusinesses, setRelatedBusinesses] = useState([])
    const [showResults, setShowResults] = useState(false)

    const [alertProp, setAlertProp] = useState({ msg: sosStrings.AWAITING_RESPONSE, severity: 'info' })
    const hasCompletedRef = useRef(false)

    useEffect(() => {
        tryGetSearchResult()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    /* function to get search result while the search does not have a status
    this function will be called 24 times, for approximately 4 minutes
    if after 4 minutes the search does not have a status, an alert will be shown */
    const tryGetSearchResult = (tryNumber = 0) => {
        // If we already got a response, don't keep polling
        if (hasCompletedRef.current) return

        if (tryNumber >= MAX_RETRIES_FOR_SOS_SEARCH) {
            setAlertProp({ msg: sosStrings.TIMEOUT, severity: 'warning' })
            return
        }

        let info = { searchId: sosSearchId }
        if (!isQuickSearch) info.applicantId = applicantId

        setTimeout(() => {
            // Check again after timeout in case it completed during the wait
            if (hasCompletedRef.current) return

            getSearchResult(info)()
                .then(res => {
                    // Check ref again before processing
                    if (hasCompletedRef.current) return

                    if (res?.sosSearchStatus) {
                        handleResponseFinished(res)
                    } else {
                        tryGetSearchResult(tryNumber + 1)
                    }
                })
        }, tryNumber === 0 ? 0 : 10000)  // No delay for first call, 10 seconds for subsequent calls
    }

    const handleResponseFinished = (res) => {
        hasCompletedRef.current = true
        const status = res.sosSearchStatus

        if (status === 'COMPLETED' || status === 'Search Completed') {
            setSearchResult(res?.response?.results?.[0] || {})
            setPossibleAlternatives(res?.response?.possibleAlternatives || [])
            setRelatedBusinesses(res?.response?.relatedBusinesses || [])
            setShowResults(true)
            return;
        }

        let alertMessage, severityValue;
        if (status === 'NO_RESULTS' || status === 'No Results') {
            alertMessage = sosStrings.NO_RESULTS_PREFIX + res?.searchQuery + sosStrings.NO_RESULTS_SUFFIX
            severityValue = 'warning'
        }
        if (status === 'ERROR' || status === 'Search Error') {
            alertMessage = sosStrings.SEARCH_ERROR
            severityValue = 'error'
        }
        setAlertProp({ msg: alertMessage, severity: severityValue })
    }


    const handleAlternativeSearch = (sosId, businessName) => {
        search({ sosId, state, businessName })
    }

    return (
        <div className='mt-5'>
            {
                showResults ?
                    <SearchResultCard
                        searchResult={{ ...searchResult, sosSearchId }}
                        possibleAlternatives={possibleAlternatives}
                        relatedBusinesses={relatedBusinesses}
                        viewResult={viewResult}
                        searchAlternative={handleAlternativeSearch}
                        state={state}
                        isQuickSearch={isQuickSearch}
                        refreshSavedRecords={refreshSavedRecords}
                        creditCosts={creditCosts}
                    />
                    :
                    <Alert severity={alertProp.severity}> {alertProp.msg} </Alert>
            }
        </div>
    )
}

export default CurrentSearch